function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.394,47.51a2.54,2.54,0,0,1-2.541,2.541H2.541A2.54,2.54,0,0,1,0,47.51V2.541A2.54,2.54,0,0,1,2.541,0H26.853a2.54,2.54,0,0,1,2.541,2.541Z",
  fill: "#046eab"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.316,27.027A3.2,3.2,0,0,1,7.51,23.833H22.139a3.2,3.2,0,0,1,3.194,3.194h0a3.2,3.2,0,0,1-3.194,3.194H7.51a3.194,3.194,0,0,1-3.194-3.194Z",
  transform: "translate(0.004 0.024)",
  fill: "#19457a"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 2.144,
  cy: 2.144,
  r: 2.144,
  transform: "translate(5.507 24.907)",
  fill: "#59b4d9"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.316,17.548A3.2,3.2,0,0,1,7.51,14.354H22.139a3.2,3.2,0,0,1,3.194,3.194h0a3.2,3.2,0,0,1-3.194,3.194H7.51a3.2,3.2,0,0,1-3.194-3.194Z",
  transform: "translate(0.004 0.015)",
  fill: "#19457a"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 2.144,
  cy: 2.144,
  r: 2.144,
  transform: "translate(5.507 15.419)",
  fill: "#59b4d9"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.316,8.068A3.2,3.2,0,0,1,7.51,4.874H22.139a3.2,3.2,0,0,1,3.194,3.194h0a3.2,3.2,0,0,1-3.194,3.194H7.51A3.193,3.193,0,0,1,4.316,8.068Z",
  transform: "translate(0.004 0.005)",
  fill: "#19457a"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 2.144,
  cy: 2.144,
  r: 2.144,
  transform: "translate(5.507 5.929)",
  fill: "#59b4d9"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M49.989,45.394a4.609,4.609,0,0,0-4.59-4.631,4.079,4.079,0,0,0-.56.04,12.529,12.529,0,0,0,.434-3.264,12.227,12.227,0,0,0-23.845-3.922,8.214,8.214,0,0,0-2.733-.471,8.44,8.44,0,0,0,0,16.88l.012,0v0H45.772L45.767,50a4.607,4.607,0,0,0,4.222-4.609",
  transform: "translate(0.011 0.025)",
  fill: "#1590cf"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M23.141,50.025a8.446,8.446,0,0,1,3.985-14.217,8.216,8.216,0,0,1,2.769-.149,12.293,12.293,0,0,1,6.855-9.882,12.192,12.192,0,0,0-15.322,7.838,8.21,8.21,0,0,0-2.733-.471,8.44,8.44,0,0,0,0,16.88.05.05,0,0,1,.012,0v0Z",
  transform: "translate(0.011 0.025)",
  fill: "#fff",
  opacity: 0.2
});

var SvgAppServicePlans = function SvgAppServicePlans(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50.051,
    viewBox: "0 0 50 50.051",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppServicePlans, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/app_service_plans.3420af9a.svg";
export { ForwardRef as ReactComponent };